import { render } from "./AddressInput.vue?vue&type=template&id=28383d4b&scoped=true&ts=true"
import script from "./AddressInput.vue?vue&type=script&lang=ts"
export * from "./AddressInput.vue?vue&type=script&lang=ts"

import "./AddressInput.vue?vue&type=style&index=0&id=28383d4b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28383d4b"]])

export default __exports__